module.exports = __webpack_public_path__ + "static/media/snowboarding.d98bf0b5.svg";